import React from 'react';
import './style.scss';

export const OverseasRealEstatePositionHeader = () => {
  return (
    <>
      <div className="overseasRealEstatePositionHeader">
        <div className="overseasRealEstatePositionHeader_symbolName">案件</div>
        <div className="overseasRealEstatePositionHeader_realEstateName">対象物件名</div>
        <div className="overseasRealEstatePositionHeader_paLDistMonth">任意組合決算月</div>
        <div className="overseasRealEstatePositionHeader_rate">
          <span>事業開始時</span>
          <span>為替レート</span>
          <span>(1.00米ドル)</span>
        </div>
        <div className="overseasRealEstatePositionHeader_investmentJPY">出資金額(¥)</div>
        <div className="overseasRealEstatePositionHeader_contractDate">契約締結日</div>
        <div className="overseasRealEstatePositionHeader_projectedHoldingPeriod">想定保有期間</div>
        <div className="overseasRealEstatePositionHeader_operatingEndDate"><span>任意組合終了日</span><span>(事業終了予定日)</span></div>
        <div className="overseasRealEstatePositionHeader_status">ステータス</div>
        <div className="overseasRealEstatePositionHeader_contract">契約関連書類</div>
      </div>
    </>
  );
};
